import { render } from "./ProfileEditForm.vue?vue&type=template&id=977ea298"
import script from "./ProfileEditForm.vue?vue&type=script&lang=js"
export * from "./ProfileEditForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__